import React from 'react';

// LinkedIn profile mappings for people mentioned in career details
// Format: "Full Name": "linkedin-url" or "Full Name": ["url1", "url2"] for multiple people
// For duplicate names, you can use: "Full Name (Context)": "linkedin-url" for more specific matching
export const linkedInProfiles: Record<string, string | string[]> = {
  "Joshua Hoskins": "https://www.linkedin.com/in/jhoskins",
  "Yogesh Rankawat": "https://www.linkedin.com/in/yogeshrankawat",
  "Abhishek": "https://www.linkedin.com/in/abhishekpareeksfdc",
  "Madan": "https://www.linkedin.com/in/madan-v-853b1329",
  "Manish": "https://www.linkedin.com/in/manish-s-a0a078141",
  "Naveen": "https://www.linkedin.com/in/navin-dayama-685407133",
  "Hemant": "https://www.linkedin.com/in/hemant-soni-86aab749",
  "Adarsh": "https://www.linkedin.com/in/adarsh-sharma-59a77a110",
  "Raghuveer": "https://www.linkedin.com/in/salesforceguruji",
  "Ankit Kumar": "https://www.linkedin.com/in/ankit-kumar-953922aa",
  "Parag": "https://www.linkedin.com/in/parag-b-40b76112a",
  "Anoop": "https://www.linkedin.com/in/anoop-kumar-8496bba0",
  "Sumit Tanwar": "https://www.linkedin.com/in/sumit-tanwar-11446085",
  "Rohit Sharma": "https://www.linkedin.com/in/rohit-sharma-6b843129",
  "Prakash Gyamlani": "https://www.linkedin.com/in/prakashgyamlani",
  "Sumit Mishra": "https://www.linkedin.com/in/sumitmishraappirio",
  "Vipin Prakash Gupta": "https://www.linkedin.com/in/vipinpgupta",
  "Bharti Mahat": "https://www.linkedin.com/in/bharti-mehta-70b3207a",
  "Megha Agarwal": "https://www.linkedin.com/in/megha-agarwal-63417823",
  "Suraj Rajoria": "https://www.linkedin.com/in/suraj-rajoria-61314a55",
  "Varun Vatsa": "https://www.linkedin.com/in/varunvatsa",
  "Neeraj Gupta": "https://www.linkedin.com/in/neerajgupta999",
  "Manmeet Manethiya": "https://www.linkedin.com/in/manmeet-manethiya-21454410",
  "Anjali Khandelwal": "https://www.linkedin.com/in/anjali-khandelwal-b44b031a",
  "Urminder Singh": "https://www.linkedin.com/in/urminder-singh",
  "Nitin Goyal": "https://www.linkedin.com/in/nitin-goyal-00825928",
  "Manuraj Hada": "https://www.linkedin.com/in/manurajhada",
  "Vikram Fartyal": "https://www.linkedin.com/in/vikramfartyal",
  "Himanshu Parashar": "https://www.linkedin.com/in/mehimanshu",
  "Alan Leung": "https://www.linkedin.com/in/alanleung",
  "Vinay Prakash Dwivedi": "https://www.linkedin.com/in/vinay-prakash-dwivedi-482ba663",
  "Vivek Dhanopia": "https://www.linkedin.com/in/vivek-dhanopia-53b40419",
  "Rajesh Kumar": "https://www.linkedin.com/in/rajesh-kumar-77b308108",
  "Umesh V Sharma": "https://www.linkedin.com/in/umesh-v-sharma-937a1138",
  "Surender Singh Rathore": "https://www.linkedin.com/in/surendrasinghrathore",
  "Kapil Sharma": "https://www.facebook.com/kapil.sharma.1806253",
  "Mohan Maurya": "https://www.facebook.com/mohan.mourya",
  "Nirmal Sharma": "https://www.linkedin.com/in/nirmal-sharma-500b0926",
  "Gulshan Mathur": "https://www.linkedin.com/in/gulshanmathur",
  "Anish Sharma": "https://www.linkedin.com/in/anish-sharma-b8348715",
  "Dheeraj Saini": "https://www.linkedin.com/in/dheeraj-saini-24389836",
  "Somaydeep Sarkar": "https://www.linkedin.com/in/soumyadeep-sarkar-34658678",
  "Prateek Gehlotra": "https://www.linkedin.com/in/prateek-g-88133134",
  "Ravi Yadav": "https://www.linkedin.com/in/ravi-yadav-21357416",
  "Shalu Rajawat": "https://www.linkedin.com/in/shalu-j-rajawat-465179146",
  "Tripti Vijay": "https://www.linkedin.com/in/tripti-vijay-6354871b",
  "Shweta Jain": "https://www.linkedin.com/in/shweta-jain-434403a4",
  "Naval Singh Rathore": "https://www.linkedin.com/in/naval-rathore-19990022",
  "Anupam Somani": "https://www.linkedin.com/in/anupamsomani",
  "Krishna Kumar Prajapati": "https://www.linkedin.com/in/krishna-prajapati-baa61140",
  "Ankur Bansal": "https://www.linkedin.com/in/ankur-bansal-40048516",
  "Neeraj Gupta (MetaCube)": "https://www.linkedin.com/in/neeraj-gupta-aabaa423",
  "Neeraj Gupta (College)": "https://www.linkedin.com/in/neerajgupta999",
  "Kumar Mayank": "https://www.linkedin.com/in/kumar-mayank-155bba196",
  "Rahul Biswas": "https://www.linkedin.com/in/rahul-biswas-sqldba",
  "Chandra Shekhar Sidharth": "https://www.linkedin.com/in/chandra-shekhar-sidharth-a0bba661",
  "Prashant Kumar": "https://www.linkedin.com/in/itsprashantkumar"
};

// Function to parse text and convert names to LinkedIn links
export function parseLinkedInLinks(text: string): (string | React.ReactElement)[] {
  const parts: (string | React.ReactElement)[] = [];
  let remainingText = text;
  let keyCounter = 0;

  // Separate names into context-specific (with parentheses) and regular names
  const contextSpecificNames: string[] = [];
  const regularNames: string[] = [];
  
  Object.keys(linkedInProfiles).forEach(name => {
    if (name.includes('(') && name.includes(')')) {
      contextSpecificNames.push(name);
    } else {
      regularNames.push(name);
    }
  });

  // Sort by length (longest first) to avoid partial matches
  const sortedContextNames = contextSpecificNames.sort((a, b) => b.length - a.length);
  const sortedRegularNames = regularNames.sort((a, b) => b.length - a.length);

  while (remainingText.length > 0) {
    let earliestMatch: { name: string; index: number; length: number; displayName: string } | null = null;

    // First, try to match context-specific names (e.g., "Neeraj Gupta (MetaCube)")
    for (const name of sortedContextNames) {
      // Extract the base name without context for matching
      const baseName = name.split('(')[0].trim();
      const nameRegex = new RegExp(`\\b${baseName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
      const match = remainingText.match(nameRegex);
      
      if (match && match.index !== undefined) {
        const index = match.index;
        if (!earliestMatch || index < earliestMatch.index) {
          earliestMatch = { 
            name, 
            index, 
            length: match[0].length,
            displayName: baseName // Display only the name, not the context
          };
        }
      }
    }

    // If no context-specific match, try regular names
    if (!earliestMatch) {
      for (const name of sortedRegularNames) {
        // Skip if this name is already handled by context-specific entry
        const hasContextVersion = contextSpecificNames.some(ctxName => 
          ctxName.split('(')[0].trim().toLowerCase() === name.toLowerCase()
        );
        if (hasContextVersion) continue;

        const nameRegex = new RegExp(`\\b${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
        const match = remainingText.match(nameRegex);
        
        if (match && match.index !== undefined) {
          const index = match.index;
          if (!earliestMatch || index < earliestMatch.index) {
            earliestMatch = { 
              name, 
              index, 
              length: match[0].length,
              displayName: name
            };
          }
        }
      }
    }

    if (earliestMatch) {
      // Add text before the match
      if (earliestMatch.index > 0) {
        parts.push(remainingText.substring(0, earliestMatch.index));
      }

      // Add the LinkedIn link
      const linkedInUrl = linkedInProfiles[earliestMatch.name];
      const url = Array.isArray(linkedInUrl) ? linkedInUrl[0] : linkedInUrl;
      
      parts.push(
        <a
          key={`linkedin-${keyCounter++}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="linkedin-link"
        >
          {earliestMatch.displayName}
        </a>
      );

      // Update remaining text
      remainingText = remainingText.substring(earliestMatch.index + earliestMatch.length);
    } else {
      // No more matches, add remaining text
      parts.push(remainingText);
      break;
    }
  }

  return parts;
}

